export const hexadecimalEq = (a?: string | null, b?: string | null) => {
  if (!a || !b) {
    return false
  }
  
  return a.toLowerCase() === b.toLowerCase()
}
